module.exports = __webpack_public_path__ + "static/media/lachiripa-bw.5d7d2233.png";